import React from 'react';
import '../assets/css/style.css';

const ErrorPage = () => {
    return (
        <>
            <div className="header-layer-bg"></div>

            <main className="wrapper">
                <section className="error-page">
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-10 offset-lg-1">
                                <div className="error-content text-center">
                                    <div className="heading">404</div>
                                    <h1>Pagina no encontrada</h1>
                                    <p>Oops! TNo hay nada aqui.</p>

                                  

                                    <div className="btn_group">
                                        <a href='/' className="btn black">Llevame a Inicio</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};

export default ErrorPage;